

























































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { UserFamily } from '@/api/models/user'
import { cloneDeep, orderBy } from 'lodash'
import { SortOrder } from '@/types'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'select',
        align: 'center'
      }
    ]
  },
  {
    width: '28',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'name',
        headerText: '家族氏名',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '28',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'nameKana',
        headerText: '家族氏名（カナ）',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'id',
        headerText: '利用者番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 90,
    resizable: true,
    movable: true,
    items: [
      {
        name: 'memo',
        headerText: 'メモ'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'birthday',
        headerText: '生年月日',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'lendCount',
        headerText: '貸出数',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reserveCount',
        headerText: '予約数',
        align: 'right',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 75,
    resizable: true,
    movable: true,
    items: [
      {
        name: 'detail',
        headerText: '',
        align: 'center'
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: {
    DataTable
  }
})
export default class FamilyUsageSituationTable extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  create!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  edit!: boolean

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Array,
    default: () => []
  })
  items!: UserFamily[]

  @Prop({
    type: Object
  })
  selectedUser!: UserFamily | null

  internalItems: UserFamily[] = []

  sortName: string = ''

  sortOrder: SortOrder = ''

  // プロパティが複雑なので一つ一つ指定
  get sortedInternalItems(): UserFamily[] {
    if (this.sortName) {
      return orderBy<UserFamily>(
        this.internalItems,
        (item: UserFamily) => {
          switch (this.sortName) {
            case 'name':
              return item.personal.name
            case 'nameKana':
              return item.personal.nameKana
            case 'id':
              return item.base.id
            case 'birthday':
              return item.personal.birthday
            case 'lendCount':
              return item.lendCollections.length
            case 'reserveCount':
              return item.reserveCollections.length
            default:
              return item[this.sortName as keyof UserFamily]
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.internalItems
  }

  get createOrEdit(): boolean {
    return this.create || this.edit
  }

  get allCols(): Col[] {
    if (this.edit) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.createOrEdit) {
      return this.allCols.filter((item: Col) => {
        return item.items[0].name !== 'select'
      })
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  get checked() {
    return (userFamily: UserFamily) => {
      if (this.selectedUser === null) return false

      return userFamily.base.id === this.selectedUser.base.id
    }
  }

  get hasMemoOrNote() {
    return (userFamily: UserFamily) => {
      return userFamily.memos.length > 0 || userFamily.notes.length > 0
    }
  }

  @Watch('edit')
  initializeSort(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  @Watch('items')
  changeItems(): void {
    this.internalItems = []
    this.items.forEach((item: UserFamily) => {
      this.internalItems.unshift(cloneDeep(item))
    })
  }

  remove(index: number): void {
    this.internalItems.splice(index, 1)

    this.emitChange()
  }

  emitChange(): void {
    this.$emit('change', [...this.internalItems].reverse())
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  @Emit('select')
  onClickRow(index: number) {
    return this.items.find(
      item => item.base.id === this.sortedInternalItems[index].base.id
    )
  }

  @Emit('click:memo')
  onClickMemo(user: UserFamily) {
    return user
  }

  @Emit('click:detail')
  onClickDetail(user: UserFamily) {
    return user
  }
}
